export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 5-5cbb92c637ac57ace41d62aac177098b.png";